export default {

  left: [],

  right: []
  
}